//TODO : Refactor after ai
import type { HTMLAttributes } from "react";

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: number;
  thickness?: number;
}

/** Indeterminate loading ring. */
export function Spinner({
  size = 20,
  thickness,
  className = "",
  ...rest
}: SpinnerProps) {
  const borderWidth = thickness ?? Math.max(2, Math.round(size / 10));
  return (
    <span
      className={`bui-spinner ${className}`}
      style={{ width: size, height: size, borderWidth }}
      role="status"
      aria-label="Loading"
      {...rest}
    />
  );
}
